import React from 'react';
const Trailer = () => {
  return (
    <div>
      <h1>Trailer</h1>
      <p>This is the Trailer page content.</p>
    </div>
  );
};

export default Trailer;